import React, { useState } from 'react';
import '../../CSS/cardStudio.css';
import { TextField, Typography, Slider, Box, Grid, FormControlLabel, RadioGroup, Radio, FormLabel, Switch, Tooltip, IconButton } from '@mui/material';
import { useStudio } from '../../Context/StudioContext';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import { X, Plus } from 'lucide-react';


const Page3Settings = () => {
  const { formData, setFormData } = useStudio();

  const handleChange = (field) => (e) => {
    setFormData(prev => ({ ...prev, [field]: e.target.value }));
  };

  const showDressCode = formData.showDressCode;

  const handleToggle = (e) => {
    const isChecked = e.target.checked;

    setFormData((prev) => ({
      ...prev,
      showDressCode: isChecked,

    }));
  };

  // ── Dress code colour palette helpers ──────────────────────────
  const dressCodeColours = formData.dressCodeColours || [];

  const handleAddColour = () => {
    if (dressCodeColours.length >= 6) return;
    setFormData(prev => ({
      ...prev,
      dressCodeColours: [...(prev.dressCodeColours || []), '#c8a96e'],
    }));
  };

  const handleColourChange = (index, value) => {
    setFormData(prev => {
      const updated = [...(prev.dressCodeColours || [])];
      updated[index] = value;
      return { ...prev, dressCodeColours: updated };
    });
  };

  const handleRemoveColour = (index) => {
    setFormData(prev => {
      const updated = [...(prev.dressCodeColours || [])];
      updated.splice(index, 1);
      return { ...prev, dressCodeColours: updated };
    });
  };


  return (
    <Box>
      <Typography variant="h6">Maklumat Pengantin &amp; Majlis</Typography>

      <Grid sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>

        <Grid sx={{ minWidth: 0 }}>
          <Typography variant="body1" color="text.secondary" fontSize={12}>
            Bilangan Penganjur
          </Typography>

          <div className="radio-toggle-group">
            <label
              className={`radio-toggle ${formData.eventHost === 'satu' ? 'selected' : ''}`}
            >
              <input
                type="radio"
                name="eventHost"
                value="satu"
                checked={formData.eventHost === 'satu'}
                onChange={handleChange('eventHost')}
              />
              <PersonIcon fontSize="small" />
              Satu
            </label>

            <label
              className={`radio-toggle ${formData.eventHost === 'dua' ? 'selected' : ''}`}
            >
              <input
                type="radio"
                name="eventHost"
                value="dua"
                checked={formData.eventHost === 'dua'}
                onChange={handleChange('eventHost')}
              />
              <PeopleIcon fontSize="small" />
              Dua
            </label>
          </div>



        </Grid>

        <Grid sx={{ minWidth: 0 }}>
          <Typography variant="body1" color="text.secondary" fontSize={12}>
            Pihak Majlis
          </Typography>

          <div className="radio-toggle-group">
            <label
              className={`radio-toggle ${formData.eventSide === 'lelaki' ? 'selected' : ''} ${formData.eventHost === 'dua' ? 'disabled' : ''}`}
            >
              <input
                type="radio"
                name="eventSide"
                value="lelaki"
                checked={formData.eventSide === 'lelaki'}
                onChange={handleChange('eventSide')}
                disabled={formData.eventHost === 'dua'}
              />
              <ManIcon fontSize="small" />
              Lelaki
            </label>

            <label
              className={`radio-toggle ${formData.eventSide === 'perempuan' ? 'selected' : ''} ${formData.eventHost === 'dua' ? 'disabled' : ''}`}
            >
              <input
                type="radio"
                name="eventSide"
                value="perempuan"
                checked={formData.eventSide === 'perempuan'}
                onChange={handleChange('eventSide')}
                disabled={formData.eventHost === 'dua'}
              />
              <WomanIcon fontSize="small" />
              Perempuan
            </label>
          </div>

        </Grid>

      </Grid>



      {formData.eventHost === 'satu' && (
        <TextField
          label="Nama Bapa & Ibu Pengantin"
          fullWidth
          value={formData.parentName}
          onChange={handleChange('parentName')}
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
      )}

      {formData.eventHost === 'dua' && (
        <>
          <TextField
            label="Nama Bapa & Ibu Pengantin (Pihak Lelaki)"
            fullWidth
            value={formData.parentNameMale}
            onChange={handleChange('parentNameMale')}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Nama Bapa & Ibu Pengantin (Pihak Perempuan)"
            fullWidth
            value={formData.parentNameFemale}
            onChange={handleChange('parentNameFemale')}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
        </>
      )}

      <TextField
        label="Nama Penuh Pengantin Lelaki"
        fullWidth
        value={formData.groomName}
        onChange={handleChange('groomName')}
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        label="Nama Penuh Pengantin Perempuan"
        fullWidth
        value={formData.brideName}
        onChange={handleChange('brideName')}
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />

      {/* ── PASANGAN 2 — same parent, just 2nd child getting married ──── */}
      {formData.coupleCount === 'dua' && (
        <Box sx={{ mt: 3, pt: 2, borderTop: '2px dashed #e0f5f4' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1b9a9b', mb: 1 }}>Pasangan 2</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            Nama penuh anak kedua yang berkahwin (penganjur sama)
          </Typography>
          <TextField
            label="Nama Penuh Pengantin Lelaki (Pasangan 2)"
            fullWidth
            value={formData.groomName2}
            onChange={handleChange('groomName2')}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Nama Penuh Pengantin Perempuan (Pasangan 2)"
            fullWidth
            value={formData.brideName2}
            onChange={handleChange('brideName2')}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
        </Box>
      )}

      <TextField
        label="Pembukaan"
        fullWidth
        value={formData.openingText}
        onChange={handleChange('openingText')}
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        label="Ayat Ucapan"
        fullWidth
        multiline
        minRows={3}
        value={formData.greetingText}
        onChange={handleChange('greetingText')}
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        label="Penutup"
        fullWidth
        multiline
        minRows={2}
        value={formData.closingText}
        onChange={handleChange('closingText')}
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />

      <FormControlLabel
        sx={{ mt: 1 }}
        label="Kod Pakaian"
        control={
          <Switch
            checked={showDressCode}
            onChange={handleToggle}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: '#68D2D2',
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#68d2d294',
              },
            }}
          />
        }
      />

      {showDressCode && (
        <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {/* Dress code label */}
          <TextField
            fullWidth
            label="Kod Pakaian"
            value={formData.dressCode}
            placeholder='Formal/Tradisional'
            onChange={handleChange("dressCode")}
            InputLabelProps={{ shrink: true }}
            margin="none"
          />

          {/* Notes */}
          <TextField
            fullWidth
            label="Nota Tambahan (Pilihan)"
            placeholder='cth: Elakkan warna putih dan hitam'
            multiline
            sx={{ mt: 1 }}
            minRows={2}
            value={formData.dressCodeNotes || ''}
            onChange={handleChange("dressCodeNotes")}
            InputLabelProps={{ shrink: true }}
          />

          {/* Colour palette */}
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontSize: 12 }}>
              Palet Warna Pakaian (max 6 warna)
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
              {dressCodeColours.map((colour, i) => (
                <Box key={i} sx={{ position: 'relative', display: 'inline-flex' }}>
                  <Tooltip title={colour} placement="top">
                    <Box
                      component="input"
                      type="color"
                      value={colour}
                      onChange={e => handleColourChange(i, e.target.value)}
                      sx={{
                        width: 38,
                        height: 38,
                        border: '2px solid #ddd',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        padding: 0,
                        appearance: 'none',
                        backgroundColor: colour,
                        '&::-webkit-color-swatch-wrapper': { padding: 0 },
                        '&::-webkit-color-swatch': { border: 'none', borderRadius: '50%' },
                      }}
                    />
                  </Tooltip>
                  <IconButton
                    size="small"
                    onClick={() => handleRemoveColour(i)}
                    sx={{
                      position: 'absolute',
                      top: -6,
                      right: -6,
                      width: 16,
                      height: 16,
                      backgroundColor: '#fff',
                      border: '1px solid #ccc',
                      padding: 0,
                      '&:hover': { backgroundColor: '#fee2e2' },
                    }}
                  >
                    <X size={10} />
                  </IconButton>
                </Box>
              ))}
              {dressCodeColours.length < 6 && (
                <Tooltip title="Tambah warna">
                  <IconButton
                    onClick={handleAddColour}
                    size="small"
                    sx={{
                      width: 38,
                      height: 38,
                      border: '2px dashed #bbb',
                      borderRadius: '50%',
                      color: '#888',
                    }}
                  >
                    <Plus size={16} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Box>
        </Box>
      )}


    </Box>
  );
};

export default Page3Settings;
